<div class="flex flex-direction-column" *ngIf="artifacts.length !== 0">
	<div class="flex-5 accent-text sticky title-padding flex-direction-row flex-align-start">
		<div class="flex">
			{{ title }}
		</div>
		<div class="flex flex-align-center flex-justify-end">
			<mat-checkbox #all (change)="setAll($event)" class="set_all_checkbox"></mat-checkbox>
		</div>
	</div>
	<div class="flex-grow">
		<mat-selection-list #artifactList (selectionChange)="changeChecked()">
			<mat-list-option *ngFor="let a of artifacts" [value]="a"> {{ a.externalIdentifier.group }}:{{ a.externalIdentifier.name }}:{{ a.identifier.version }} </mat-list-option>
		</mat-selection-list>
	</div>
	<div class="flex-10 flex-align-center flex-justify-center">
		<button mat-button id="ok_button" color="accent" style="transform-style: preserve-3d" (click)="execute()">
			{{ buttonLabel }}
		</button>
	</div>
</div>
